import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Component } from 'react';
import { Element } from 'react-scroll';
import Select from 'react-select';
import makeAnimated from 'react-select/animated';
import { propArrayShape, propBool, propNumber, propShape, propStr, } from '../../../../../helpers/custom-prop-types';
import InputError from '../../InputError';
class Select2FieldsComponent extends Component {
    constructor(props) {
        super(props);
        this.getState = (props) => {
            const { candidateValues, input: { value: inputValue }, maximum, } = props;
            const options = !maximum || (maximum && inputValue.length < maximum)
                ? candidateValues
                : [];
            const styles = {
                control: this.controlFn,
                dropdownIndicator: this.dropdownIndicatorFn,
                indicatorSeparator: this.indicatorSeparatorFn,
                singleValue: this.singleValueFn,
                valueContainer: this.valueContainerFn,
            };
            return {
                options,
                styles,
            };
        };
        this.onChange = (values) => {
            const { input } = this.props;
            input.onChange(values);
        };
        this.onBlur = () => {
            const { input } = this.props;
            input.onBlur(input.value);
        };
        this.controlFn = (provided) => {
            const { customStyles, meta } = this.props;
            const controlStyles = Object.assign(Object.assign({}, provided), customStyles.control);
            if (meta && meta.touched && meta.error) {
                return Object.assign(Object.assign({}, controlStyles), { borderColor: '#AD343E !important' });
            }
            return controlStyles;
        };
        this.singleValueFn = (provided) => {
            const { customStyles, isRfp } = this.props;
            const defaultStyles = Object.assign(Object.assign({}, provided), { margin: '6px 0', maxWidth: 'calc(100% - 2px)', position: 'static', textOverflow: 'clip', transform: 'none', whiteSpace: 'normal', wordBreak: 'break-all' });
            if (customStyles.singleValue) {
                return Object.assign(Object.assign({}, defaultStyles), customStyles.singleValue);
            }
            if (!isRfp) {
                return provided;
            }
            return defaultStyles;
        };
        this.valueContainerFn = (provided) => {
            const { customStyles, isRfp } = this.props;
            const defaultStyles = Object.assign(Object.assign({}, provided), { padding: '2px 0 2px 8px' });
            if (customStyles.valueContainer) {
                return Object.assign(Object.assign({}, defaultStyles), customStyles.valueContainer);
            }
            if (!isRfp) {
                return provided;
            }
            return defaultStyles;
        };
        this.indicatorSeparatorFn = (provided) => {
            const { isRfp } = this.props;
            if (!isRfp) {
                return provided;
            }
            return Object.assign(Object.assign({}, provided), { display: 'none' });
        };
        this.dropdownIndicatorFn = (provided) => {
            const { isRfp } = this.props;
            if (!isRfp) {
                return provided;
            }
            return Object.assign(Object.assign({}, provided), { padding: '8px 10px 8px 0' });
        };
        this.noOptionMessage = () => {
            const { input: { value: inputValue }, maximum, } = this.props;
            if (maximum && inputValue.length >= maximum) {
                return `選択できるのは${maximum}つまでです`;
            }
            return '選択肢がありません';
        };
        this.state = this.getState(props);
        this.animatedComponents = Object.assign(Object.assign({}, makeAnimated()), props.components);
    }
    shouldComponentUpdate(nextProps) {
        const { candidateValues, input: { value }, maximum, } = this.props;
        if (candidateValues !== nextProps.candidateValues ||
            value !== nextProps.input.value ||
            maximum !== nextProps.maximum) {
            this.setState(this.getState(nextProps));
        }
        return true;
    }
    render() {
        const { blurInputOnSelect, classNamePrefix, input, isDisabled, isMulti, isSearchable, menuPosition, meta, placeholder, readOnly, } = this.props;
        const { options, styles } = this.state;
        return (_jsxs(_Fragment, { children: [_jsx(Element, { name: `${input.name}_view` }), _jsx(Select, { blurInputOnSelect: blurInputOnSelect, classNamePrefix: classNamePrefix, components: this.animatedComponents, isDisabled: isDisabled, isMulti: isMulti, isSearchable: isSearchable, menuPosition: menuPosition, name: input.name, noOptionsMessage: this.noOptionMessage, onBlur: this.onBlur, onChange: this.onChange, options: options, placeholder: placeholder, readOnly: readOnly, styles: styles, value: input.value }), _jsx(InputError, { meta: meta })] }));
    }
}
Select2FieldsComponent.propTypes = {
    blurInputOnSelect: propBool(),
    candidateValues: propArrayShape().isRequired,
    classNamePrefix: propStr(),
    components: propShape(),
    customStyles: propShape(),
    input: propShape().isRequired,
    isDisabled: propBool(),
    isMulti: propBool(),
    isRfp: propBool(),
    isSearchable: propBool(),
    maximum: propNumber().isRequired,
    menuPosition: propStr(),
    meta: propShape().isRequired,
    placeholder: propStr().isRequired,
    readOnly: propBool(),
};
Select2FieldsComponent.defaultProps = {
    blurInputOnSelect: undefined,
    classNamePrefix: undefined,
    components: undefined,
    customStyles: {},
    isDisabled: false,
    isMulti: true,
    isRfp: false,
    isSearchable: true,
    menuPosition: undefined,
    readOnly: false,
};
export default Select2FieldsComponent;
